<template>
	<div class="dealers-projects">
		<action-sidebar
			title="Implementadores Asignados"
			:value="true"
			:width="644"
			@close-modal="closeModal"
		>
		<app-table
		selectable
		class="mt-5 is-not-selectable px-4"
		name="implementers"
		:selected-value="selectedValue"
		:check-all="checkAll"
		:columns="columns"
		:rows="implementers"
		:last-page="lastPage"
		:current-page="currentPage"
		@on-selected-all="allIsSelected"
		@row-is-selected="rowIsSelected"
		@on-search-event="onSearchImplementers"
		@on-page="changePage">
			<template slot="rows" slot-scope="props">
				<td class="is-not-selectable"
				v-show="showRow(columns, 1)">
					{{ props.row.name }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.email }}
				</td>
			</template>
		</app-table>
			<section class="modal-filter-footer content-buttons pt-3 pb-3">
				<v-btn
				class="btn-action caption mr-1"
				color="pink"
				@click="closeModal">
					Cancelar
				</v-btn>
				<v-btn
				class="btn-action caption ml-1"
				color="success"
				@click="deallocatedRow"
				:disabled="disabledDeallocate"
				>
					Desasignar
				</v-btn>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import tableAssign from '@/components/configuration/table-assign';

function created() {
	this.listImplementers();
}

function disabledDeallocate() {
	return this.dataSelected.length < 1;
}

async function deallocatedRow() {
	const idSelected = this.dataSelected.map(item => item.id);
	const body = {
		implementersIds: idSelected,
	};
	try {
		await this.$http.delete(`distributaries/${this.id}/implementers`, { data: body });
		this.showNotification('Los implementadores han sido desasignados');
		this.closeModal();
		this.listImplementers();
	} catch (error) {
		this.showError();
	}
}

function rowIsSelected(row) {
	this.implementers = this.selectIsRow(this.implementers, this.selectedValue, row);
	this.checkAll = this.every(this.implementers, this.selectedValue);
	this.dataSelected = this.implementers.filter(r => r.flagSelected);
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.dataSelected = [];
	this.implementers = this.implementers.map((item) => {
		const newRow = { ...item };
		newRow.isSelected = checked;
		if (checked) {
			this.dataSelected.push(item);
		}
		return newRow;
	});
	this.implementers = this.selectIsRow(this.implementers, this.selectedValue, false, checked);
}

function onSearchImplementers(search) {
	this.params.search = search ? search.trim() : null;
	this.listImplementers();
}

async function listImplementers() {
	const params = {
		page: this.params.page,
		search: this.params.search,
		perPage: 20,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/implementers`, { params });
		this.implementers = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function changePage(page) {
	this.currentPage = page;
	this.listImplementers();
}

function data() {
	return {
		action: {
			search: '',
		},
		checkAll: false,
		currentPage: 1,
		columns: [
			{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 2, name: 'Correo', value: 'mail', checked: true, visible: true },
		],
		dataSelected: [],
		implementers: [],
		lastPage: 0,
		selectedValue: 'flagSelected',
		tabs: [
			{
				id: 1,
				name: 'Asignar',
			},
			{
				id: 2,
				name: 'Asignados',
			},
		],
		tabsModel: null,
	};
}

export default {
	name: 'page-dealers-implementers',
	created,
	data,
	components: {
		actionSidebar,
		tableAssign,
	},
	computed: {
		disabledDeallocate,
	},
	methods: {
		allIsSelected,
		closeModal,
		changePage,
		deallocatedRow,
		listImplementers,
		rowIsSelected,
		onSearchImplementers,
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
};
</script>

<style lang="scss" scoped>
.content-buttons {
	display: flex;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-dealers-implementers.vue